import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import MailIcon from "../../images/create-user-icon.svg";
import { SIGNIN_ROUTE } from "../../constants/RoutePath";
import { useNavigate } from "react-router-dom";

export default function CreateNewAccountModel(props) {
  const {open, setOpen,handleClose,message, setIsoldUserCheck,isOlderUserChecking } =props
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("sm");
const navigation=useNavigate()
  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  const handleMaxWidthChange = (event) => {
    setMaxWidth(
      // @ts-expect-error autofill of arbitrary value is not handled.
      event.target.value
    );
  };

  const handleFullWidthChange = (event) => {
    setFullWidth(event.target.checked);
  };
const BackFun=()=>{
  if(isOlderUserChecking == 'IS_OLD_USER'){
    setIsoldUserCheck(false)
  }else{
    navigation(SIGNIN_ROUTE)
  }
}
  return (
    <React.Fragment>
      
      <Dialog
        className="new-account-model"
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        // onClose={handleClose}
      >
        <DialogTitle sx={{ textAlign: "right", paddingBottom: "0px" }}>
          <span  class="material-symbols-outlined confirm-email-popup-close-button" onClick={handleClose}>
            cancel
          </span>
        </DialogTitle>
        <DialogContent
          sx={{ textAlign: "center", padding: "0px 41px 48px 41px" }}
        >
          <img src={MailIcon} />
          <DialogContentText className="add-model-title">
            Check your email
          </DialogContentText>
          <DialogContentText className="add-model-text">
            {message}
           
          </DialogContentText>
          <Button
            sx={{
              padding: "11px 15px !important",
              width: "auto !important",
              mt: "20px !important",
            }}
            className="login-btn"
            variant="contained"
            size="large"
           onClick={BackFun}
          >
            Back to login
          </Button>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
